import { useState, useEffect } from 'react';
import 'react-tabs/style/react-tabs.css';
import 'moment/locale/pt-br';

import { Stack, Button } from '@mui/material';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import Input from '../../form/Input';
import InputNumber from '../../form/InputNumber';
import Checkbox from '../../form/Checkbox';
import SelectEmpresa from '../../form/SelectEmpresa';
import Select from '../../form/Select';

/* utils */
import * as TabelaAPI from '../../../api/tabela';
import { formatarNumero, formatarNumeroDecimal } from '../../../utils/masks';

function Form({
    token,
    dados,
    setDados,
    empresaId,
    empresaIds,
    handleSubmit,

    btnText,
    caminhoVoltar,
    OptionsEmpresa,
    OptionsUnidade,
}) {
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();

    function handleChange(e) {
        const { name, value, checked, type } = e.target;

        const valorNumerico = ['fator', 'fatorCorrecao'];
        if (valorNumerico.includes(name)) {
            const valorFormatado = formatarNumeroDecimal(value);
            setDados({ ...dados, [name]: valorFormatado });
        } else {
            setDados({ ...dados, [name]: type === 'checkbox' ? checked : value });
        }
    }

    async function handleOnBlur(e) {
        const { name, value, checked, type } = e.target;

        //verifica duplicidade
        if (name === 'descricao' && btnText.toLowerCase() === 'cadastrar') {
            const duplicidade = await TabelaAPI.duplicidadeDescricao(dados.empresaId, 'Embalagem', value);

            if (duplicidade?.uuid) {
                setFlashMessage('Registro em duplicidade!', 'warning');
                return navigate(`/Embalagens/CreateOrEdit`, {
                    uuid: duplicidade.uuid,
                });
            }
        }
    }
    function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();

        if (!dados.unidadeId) {
            dados.unidadeId = parseInt(document.getElementById('unidadeId').value);
        }

        handleSubmit(dados);
    };

    return (
        <form onSubmit={submit}>
            <h1>Embalagem</h1>
            <div>
                <SelectEmpresa
                    text="Selecione a Empresa"
                    name="empresaId"
                    options={OptionsEmpresa}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.empresaId || ''}
                    required
                    notOptNull={true}
                />
                <Input
                    text="Descrição"
                    type="text"
                    name="descricao"
                    placeholder="Embalagem"
                    inputWidth="250px"
                    title="Digite o nome da embalagem"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.descricao || ''}
                    required={true}
                />
                <Select
                    name="unidadeId"
                    text="Unidade"
                    options={OptionsUnidade}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.unidadeId}
                    isEnum={false}
                    notOptNull={true}
                />
                <InputNumber
                    text="Fator"
                    type="text"
                    name="fator"
                    placeholder="Fator"
                    inputWidth="100px"
                    title="digite o fator da unidade"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.fator ? formatarNumero(dados.fator) : ''}
                />
                <InputNumber
                    text="Fator Correção"
                    type="text"
                    name="fatorCorrecao"
                    placeholder="Fator"
                    inputWidth="100px"
                    title="digite o fator de correção da unidade, exemplo de uso, conversão de litros para dividir por 1000"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.fatorCorrecao ? formatarNumero(dados.fatorCorrecao) : ''}
                />
                <Checkbox
                    title="Informa que precisa ser pesado no movimento"
                    text="Pesável"
                    name="pesavel"
                    handleOnChange={handleChange}
                    value={dados.pesavel}
                    checked={!!dados.pesavel}
                />
                <Checkbox
                    title="Informa que a embalagem será utilizada nos movimentos de entrada"
                    text="Entrada"
                    name="entrada"
                    handleOnChange={handleChange}
                    value={dados.entrada}
                    checked={!!dados.entrada}
                />
                <Checkbox
                    title="Informa que a embalagem será utilizada nos movimentos de saída"
                    text="Saída"
                    name="saida"
                    handleOnChange={handleChange}
                    value={dados.saida}
                    checked={!!dados.saida}
                />
                <Checkbox
                    title="Informa que a embalagem será utilizada nos processos de industrialização"
                    text="Indústria"
                    name="industria"
                    handleOnChange={handleChange}
                    value={dados.industria}
                    checked={!!dados.industria}
                />
                <Checkbox
                    title="Informa que a embalagem aceita fração "
                    text="Aceita Fração"
                    name="aceitaFracao"
                    handleOnChange={handleChange}
                    value={dados.aceitaFracao}
                    checked={!!dados.aceitaFracao}
                />
                <Checkbox
                    title="Ativa quando marcado"
                    text="Ativo"
                    name="ativo"
                    handleOnChange={handleChange}
                    value={dados.ativo}
                    checked={!!dados.ativo}
                />
            </div>
            <div>
                <Stack direction="row" spacing={1}>
                    <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                        Voltar
                    </Button>
                    <Button type="submit" variant="contained" color="success">
                        {btnText}
                    </Button>
                </Stack>
            </div>
        </form>
    );
}
export default Form;
